import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { FooterComponent } from '../../components/footer/footer.component';

@NgModule({
  declarations: [FooterComponent],
  imports: [CommonModule, IonicModule],
  exports: [FooterComponent],
})
export class FooterModule {


}
